import { assign } from 'lodash';
import { createReducer } from '../util';
import { UPDATE_INITIAL_PROPS, UPDATE_PAGE_TYPE } from './action';
import { PropertyType } from '../../common/helpers/domain/propertyTypes';
import { State } from './type';
import { LandingPageTypes } from '../../common/helpers/domain/landingPages';

const initialState: State = {
  propertyType: undefined,
  pageType: undefined,
};

export default createReducer(initialState, {
  [UPDATE_INITIAL_PROPS]: function (
    state: State,
    action: { payload: { propertyType: PropertyType } },
  ): State {
    const { propertyType } = action.payload;
    return assign({}, state, { propertyType });
  },
  [UPDATE_PAGE_TYPE]: function (
    state: State,
    action: { payload: LandingPageTypes },
  ): State {
    return assign({}, state, { pageType: action.payload });
  },
});
